import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Observable } from 'rxjs';
import { ItemResponse } from 'bookraw/shared/models/api/item.response';
import { environment } from 'env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { ListResponse } from 'bookraw/shared/models/api/list.response';
import { UserPlacementTest } from 'bookraw/shared/models/user-placement-test.model';

@Injectable()
export class UserPlacementTestsService extends ListService<UserPlacementTest> {

  url: string = '/api/admin/userPlacementTests';

  constructor(public http: HttpClient, protected readonly loaderService: AppLoaderService) {
    super(http);
  }

  assignTests(data: { userIds: number[], assignStartsAt: string, assignExpiresAt: string }): Observable<ItemResponse<UserPlacementTest>> {
    return this.http.post<ItemResponse<UserPlacementTest>>(environment.baseURL + this.url + '/assign', data);
  }

  unAssignTests(data: { userTestIds: number[] }): Observable<ItemResponse<UserPlacementTest>> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: data };
    return this.http.delete<ItemResponse<UserPlacementTest>>(environment.baseURL + this.url + '/destroyMany', options);
  }

  getByUser(userId: string ) {
    return this.http.get<ListResponse<UserPlacementTest>>(environment.baseURL + this.url + '/byUser/' + userId);
  }
}
